import { Select } from '@driftt/tide-core-legacy'

import './style.styl'


const EmailPlaybookSelect = ({
  playbookOptions,
  onValueChange,
  selectedPlaybookId,
  isLoading,
}) => (
  <div className="playbook-condition-modal-email-select">
    <Select
      className="playbook-condition-modal-email-select-box"
      options={playbookOptions}
      value={selectedPlaybookId}
      onChange={onValueChange}
      isLoading={isLoading}
    />
  </div>
)

export default EmailPlaybookSelect



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/EmailPlaybookSelect/component.js